import firebase from "firebase";
import FaraGostarDynamicHttp from "./api/FaraGostarDynamicHttp";

var firebaseConfig = {
  apiKey: "AIzaSyCXtw4Ig2zY2Os6diuw8AIa-7hzbaC6SIs",
  authDomain: "faragostarnotification.firebaseapp.com",
  databaseURL: "https://faragostarnotification.firebaseio.com",
  projectId: "faragostarnotification",
  storageBucket: "faragostarnotification.appspot.com",
  messagingSenderId: "453984141811",
  appId: "1:453984141811:web:b56b046a6f82fdbbb3d286",
};

export const initializeFirebase = () => {
  if (firebase.apps.length === 0) {
    firebase.initializeApp(firebaseConfig);
  }
};

export const askForPermissioToReceiveNotifications = async () => {
  if (!window.config) throw new Error("تنظیمات لاگین یافت نشد");
  if (window.config && !window.config.getNotifications) return;

  try {
    const messaging = firebase.messaging();
    const localStorageToken = localStorage.getItem("firebaseToken");

    await messaging.requestPermission();
    const token = await messaging.getToken();

    if (token && token !== localStorageToken) {
      localStorage.setItem("firebaseToken", token);

      let http = await FaraGostarDynamicHttp();

      await http
        .post("notification/addNotificationToken", {
          token: token,
        })
        .then((response) => {
          // ToDo: add token!
          console.log("response", response);
        })
        .catch((error) => console.log(error));
    }

    return token;
  } catch (error) {
    // console.error(error);
  }
};
